import React from "react"
import { PageWrapper } from "./PageWrapper"
import { IBreadcrumb } from "./EOSBreadcrumb"
import { Grid } from "@cd2/components/build/es6"
import { AlertBanners } from "../Pages/AlertBanners"
import { IComponentProp } from "@cd2/tools"

interface IProps {
  title: string
  actions?: React.ReactNode
  children: React.ReactNode
  breadcrumbPath?: IBreadcrumb
  body?: React.ReactNode
  banners?: IComponentProp<typeof AlertBanners, "banners">
  minWidth?: number
  subtitle?: React.ReactNode
}

export function ShowLayout({
  title,
  actions,
  children,
  body,
  banners,
  subtitle,
  breadcrumbPath,
  minWidth = 600,
}: IProps) {
  return (
    <PageWrapper
      breadcrumbPath={breadcrumbPath}
      title={title}
      subtitle={subtitle}
      pageActions={() => <div>{actions}</div>}
      minWidth={minWidth}
      underTitleNode={
        <Grid gap={12}>
          {banners && <AlertBanners banners={banners} />}
          {body}
        </Grid>
      }
    >
      <div>{children}</div>
    </PageWrapper>
  )
}
